import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const CardStat = ({ title, value, subValue }) => (
    /* "col-6" pour en avoir 2 par ligne sur mobile, "md:col-3" pour 4 par ligne sur desktop */
    <div className="col-6 md:col-3">
        <div className="card shadow-none border-1 py-2 px-3 md:px-4 bg-white" 
             style={{ borderRadius: '8px', minHeight: '115px', borderColor: '#e5e5e5' }}>
            <div style={{ color: '#9a9a98', fontSize: '0.75rem' }}>
                {title}
            </div>
            <div style={{ fontSize: '24px', color: '#1a1a1a' }}>
                {value}
            </div>
            {subValue && (
                <div style={{ color: '#0f6e56', fontSize: '0.7rem', fontWeight: '500' }}>
                    {subValue} vs mois dernier
                </div>
            )}
        </div>
    </div>
);

const DashboardLeads = () => {
    const [stats, setStats] = useState({ 
        nouvelles: 0, 
        en_suivi: 0, 
        valides: 0, 
        realises_mois: 0, 
        progression: "" 
    });

 

    return (
        <div className="p-2">
            {/* "flex-column" sur mobile, "md:flex-row" sur desktop */}
            <div className="flex flex-column md:flex-row justify-content-between md:align-items-end mb-4" style={{ paddingBottom: '10px' }}>
                <div className="mb-3 md:mb-0">
                    <a
                    href='/historiqueMailSuivi'
                        style={{
                            fontSize: "0.65rem",
                            textTransform: "uppercase",
                            letterSpacing: "1.2px",
                            color: "#9a9a98",
                            fontWeight: "500",
                            marginBottom: "6px",
                            // textDecoration:"none"
                        }}
                    >
                        Historique de mail
                    </a>
                    <h2 className="m-0" style={{ fontSize: '1.6rem', fontWeight: '700', letterSpacing: '-0.5px' }}>
                        Mes leads
                    </h2>
                </div>
                
                <Button
                    label="Nouveau lead"
                    icon="pi pi-plus"
                    onClick={() => window.open("https://tally.so/r/b5La7e", "_blank")}
                    /* "w-full" pour mobile, "md:w-auto" pour desktop */
                    className="w-full md:w-auto"
                    style={{ 
                        backgroundColor: "#0d0d0d", 
                        border: "none", 
                        color: "#f5c542", 
                        fontSize: '0.8rem',
                        fontWeight: '700',
                        borderRadius: '8px',
                        padding: '10px 18px'
                    }}
                />
            </div>

  
          
        </div>
    );
};

export default DashboardLeads;